/******************************************************
 *                  Global exploitation Ctrl
 ********************************************************/

"use strict";


angular.module("exploitation")
	.controller("ExploitRoutesCtrl", [
		"$route", "$scope", "$compile", "$location", "$timeout", "OkinaLeafletService", "leafletData", "$anchorScroll", "$routeParams", "ExploitationService", "TransportControlPlanService", "MapService", "CONSTANTS", "Utils", "$uibModal", "toastr", "SecurityService", "MapUtils",
	function ($route, $scope, $compile, $location, $timeout, OkinaLeafletService, leafletData, $anchorScroll, $routeParams, ExploitationService, TransportControlPlanService, MapService, CONSTANTS, Utils, $uibModal, toastr, SecurityService, MapUtils) {
		OkinaLeafletService.init("map-iti", {
			markerLayerCluster: false
		});

		OkinaLeafletService.setCenter({
			lat: 47.070659,
			lng: 2.2146023,
			zoom: 6
		});

		const MARKER_PREFIX = "availableMarker";

		// moveend is also triggered after zooming
		OkinaLeafletService.addEventOnMap("moveend", 800, function () {
			loadBoardingStopAreaList();
			adjustZIndex();
		});

		$scope.LeafletService = OkinaLeafletService;
		$scope.checkAccess = SecurityService.checkAccess;
		$scope.isMarketing = SecurityService.hasRight('marketing');

		/******************************************************
		 *                  SETUP
		 ********************************************************/
		let mapAreaStopPointsBackup = {};
		let deleteRouteModal, impactInfoModal, routeDataChangedModal;
		let routeDataBackup;
		let nextPath;

		$scope.data = {
			routeId: $routeParams.routeId,
			displayPoints: false,
			networks: [],
			lines: [],
			currentRouteData: {
				stop_points: []
			},
			currentRouteTrace: [],
			currentMapAreaPoints: null,
			currentRouteFeatures: {},
			map: {},
			isFetchingStopPoints: false,
			profiles: [],
			displayMarkerAvailableBoarding: false,
			changePublishedNameAllVJ: false,
			routeDataChanged: false
		};

		$scope.populationSizes = [
			{label: "Plus de 250 000 habitants", value: 1, factor: 144},//gazoleFactor: 0.46, ngvFactor: 0.081},
			{label: "De 100 000 à 250 000 habitants", value: 2, factor: 154}, //gazoleFactor: 0.465, ngvFactor: 0.054},
			{label: "Moins de 100 000 habitants", value: 3, factor: 177}//gazoleFactor: 0.432, ngvFactor: 0.021}
		];
		$scope.populationSize = $scope.populationSizes[0];

		$scope.routeDirections = [{
			id: "A",
			label: "Aller"
		},
			{
				id: "R",
				label: "Retour"
			},
			{
				id: "North",
				label: "Nord"
			},
			{
				id: "NorthEast",
				label: "Nord-Est"
			},
			{
				id: "East",
				label: "Est"
			},
			{
				id: "SouthEast",
				label: "Sud-Est"
			},
			{
				id: "South",
				label: "Sud"
			},
			{
				id: "SouthWest",
				label: "Sud-Ouest"
			},
			{
				id: "West",
				label: "Ouest"
			},
			{
				id: "NorthWest",
				label: "Nord-Ouest"
			},
			{
				id: "ClockWise",
				label: "Sens Horaire"
			},
			{
				id: "CounterClockWise",
				label: "Sens anti horaire"
			}];

		$scope.getRouteDirection = function (direction) {
			for (let i = 0; i < $scope.routeDirections.length; i++) {
				if ($scope.routeDirections[i].id === direction) {
					return $scope.routeDirections[i];
				}
			}
		}

		function loadBoardingStopAreaList() {
			OkinaLeafletService.getMap().then(map => {
				ExploitationService.getBoardingStopAreasDetailedByCoordinates(
					map.getBounds()._southWest.lat, map.getBounds()._northEast.lat,
					map.getBounds()._southWest.lng, map.getBounds()._northEast.lng
				).then((response) => {
					$scope.data.tooManyStopAreaInScope = false;
					$scope.data.currentMapAreaPoints = response.data;
					refreshAvailableBoardingMarkersList($scope.data.currentMapAreaPoints);
				}).catch(() => {
					$scope.data.currentMapAreaPoints = [];
					refreshAvailableBoardingMarkersList([]);
					$scope.data.tooManyStopAreaInScope = true;
				});
			});
		}

		/**
		 * Restful navigation.
		 */
		if ($routeParams.routeId) {
			ExploitationService.getRoute($routeParams.routeId).then((response) => {
				const stopPointsData = response.data;
				$scope.data.currentRouteData = stopPointsData;
				$scope.data.currentNetwork = stopPointsData.network;
				OkinaLeafletService.addShapeGeoJson(JSON.parse(stopPointsData.geojson));

				OkinaLeafletService.getMap().then(() => {
					OkinaLeafletService.zoomToVisibleElements();
				});

				ExploitationService.getLines($scope.data.currentNetwork).then((response) => {
					$scope.data.lines = response.data;
					$scope.data.currentLine = stopPointsData.line;
					ExploitationService.getRoutes($scope.data.currentLine).then((response) => {
						$scope.data.routes = response.data;
						$scope.data.currentRoute = stopPointsData.id;
						$scope.loadedMap = true;
					});
				});
			}).catch(() => {
				toastr.error("", "Erreur lors de la récupération de l'itinéraire");
			});
		}


		/******************
		 * SCOPE FUNCTIONS
		 ******************/

		/**
		 * Specify which popup will be used when points get clicked on map.
		 * @type {.featureTemplates.routeStopPoint|*}
		 */
		$scope.featuresPopupTemplate = MapService.featureTemplates.routeStopPoint;


		/**
		 * Redirect to correct application route when a route is selected
		 *
		 * @param routeId
		 */
		$scope.routeSelected = function (routeId) {
			$scope.newRouteMode = false;
			$location.path("e-iti/itineraires/" + routeId);
		};

		/**
		 * Go to map-matching
		 */
		$scope.goMapMatching = function () {
			$location.path("e-iti/itineraires/" + $routeParams.routeId + "/map-matching");
		};

		$scope.importKMLFile = function () {
			ExploitationService.postKMLFile($scope.data.importFile, $scope.data.routeId).then(() => {
				toastr.success("", "Import terminé");
				$route.reload();
			}).catch((error) => {
				toastr.error(error.data.message, "Erreur lors de l'import");
			});
			$scope.data.importFile = undefined;
			$scope.data.importLoading = false;
			$scope.closeImportKMLModal();
		}

		let linkToImportKML;
		$scope.openImportKMLModal = () => {
			linkToImportKML = Utils.openModal($uibModal, "import-kml.html", $scope, "lg");
		};

		$scope.closeImportKMLModal = function () {
			linkToImportKML.close();
		};

		$scope.deleteShape = function () {
			ExploitationService.resetGeoJsonTrace($scope.data.routeId).then(() => {
				toastr.success("", "Tracé réinitialisé");
				$route.reload();
			}).catch(error => {
				toastr.error(error.data.message, "Erreur lors de la réinitialisation du tracé");
			});
			$scope.closeDeleteShapeModal();
		}

		let linkToDeleteShapeModal;
		$scope.openDeleteShapeModal = () => {
			linkToDeleteShapeModal = Utils.openModal($uibModal, "delete-shape.html", $scope, "lg");
		};

		$scope.closeDeleteShapeModal = () => {
			linkToDeleteShapeModal.close();
		};


		/**
		 * Options for sortable directive.
		 * connectWith : which list is this one linked to ?
		 * stop : called whenever an element is dragged somewhere (when element is released)
		 * In the stop function, we reset the original list so the element looks like it's been cloned.
		 * @type {{connectWith: string, stop: stop}}
		 */
		$scope.sortableOptions = {
			connectWith: ".connected-apps-container",
			stop: function (e, ui) {
				// if the element is removed from the first container and added to second not self)

				if (ui.item.sortable.droptarget && e.target != ui.item.sortable.droptarget[0]) {
					OkinaLeafletService.getMap().then(map => {
						ExploitationService.getBoardingStopAreasDetailedByCoordinates(
							map.getBounds()._southWest.lat, map.getBounds()._northEast.lat,
							map.getBounds()._southWest.lng, map.getBounds()._northEast.lng
						).then((response) => {
							mapAreaStopPointsBackup = response.data;
							$scope.data.currentMapAreaPoints = mapAreaStopPointsBackup.slice();
							refreshAvailableBoardingMarkersList($scope.data.currentMapAreaPoints);
						});
					})
				}

			}
		};

		/**
		 * Add AreaStopPoint to the route stop-points list's
		 * @param stopPoint
		 */
		$scope.addRouteDataStopPoints = (stopPoint) => {
			ExploitationService.getNetworkLinesInfoForStopPoint(stopPoint.id)
				.then((response) => {
					const data = response.data;
					if (data != null && data.length > 0) {
						const stopAreaInfo = data[0];
						$scope.data.currentRouteData.stop_points.unshift(stopAreaInfo); //Beginning of the array
					}
				});
		};

		$scope.addRouteDataStopPointsById = (id) => {
			const stopArea = $scope.data.currentMapAreaPoints.find(sa => sa.id === id);
			$scope.addRouteDataStopPoints(stopArea);
		};

		/**
		 * Down move selected route stop point
		 * @param $event
		 * @param stopPoint
		 */
		$scope.stopPointDownMove = ($event, stopPoint) => {
			const indexOfAreaPoint = $scope.data.currentRouteData.stop_points.indexOf(stopPoint);
			if (indexOfAreaPoint === $scope.data.currentRouteData.stop_points.length - 1) return; //last: impeach down move
			const tempForStopPoint = $scope.data.currentRouteData.stop_points[indexOfAreaPoint + 1];
			$scope.data.currentRouteData.stop_points[indexOfAreaPoint + 1] = $scope.data.currentRouteData.stop_points[indexOfAreaPoint];
			$scope.data.currentRouteData.stop_points[indexOfAreaPoint] = tempForStopPoint;
			$event.stopPropagation(); //pour ne pas tenter d'ouvrir le popup
		};

		/**
		 * Up move selected route stop point
		 * @param $event
		 * @param stopPoint
		 */
		$scope.stopPointUpMove = ($event, stopPoint) => {
			const indexOfAreaPoint = $scope.data.currentRouteData.stop_points.indexOf(stopPoint);
			if (indexOfAreaPoint === 0) return; //first: impeach up move
			const tempForStopPoint = $scope.data.currentRouteData.stop_points[indexOfAreaPoint - 1];
			$scope.data.currentRouteData.stop_points[indexOfAreaPoint - 1] = $scope.data.currentRouteData.stop_points[indexOfAreaPoint];
			$scope.data.currentRouteData.stop_points[indexOfAreaPoint] = tempForStopPoint;
			$event.stopPropagation(); //pour ne pas tenter d'ouvrir le popup
		};

		/**
		 * Used to return a dufferent image for markers in the stop point list, according thir position in the list.
		 * @param rank
		 * @returns {*}
		 */
		$scope.getImageByRank = function (rank) {
			if (rank === 0) {
				return CONSTANTS.MAP_MARKER_START;
			} else if (rank === $scope.data.currentRouteData.stop_points.length - 1) {
				return CONSTANTS.MAP_MARKER_END;
			} else {
				return CONSTANTS.MAP_MARKER_DEFAULT;
			}
		};

		/**
		 * Stop point selected in the list.
		 * If there's a FeatureControl control declared on the map, and if there's a feature associated with this point
		 * drawn onto the map, then use the control to select the feature and unselect all other features.
		 * @param point
		 */
		$scope.stopPointSelected = function (point) {
			let marker = OkinaLeafletService.getMarkerWithName(point.id);
			ExploitationService.setCurrentStopPoint(point);
			marker.openPopup();
		};

		/**
		 * Used to highlight elements in the stop point list.
		 * @param route
		 * @returns {boolean}
		 */
		$scope.isStopPointSelected = function (route) {
			return ExploitationService.getCurrentStopPoint() === route;
		};

		/**
		 * Remove a stop point from the stop points list.
		 * @param index
		 */
		$scope.deletePointFromRoute = function (index) {
			$scope.data.currentRouteData.stop_points.splice(index, 1);
		};

		$scope.deletePointFromRouteWithId = (id) => {
			const index = $scope.data.currentRouteData.stop_points.findIndex(sp => sp.id === id);
			if (index > -1) {
				$scope.deletePointFromRoute(index);
			}
		};

		$scope.cancelEdition = function () {
			$scope.data.currentRouteData = routeDataBackup;
		};

		/**
		 * Open the route modal to edit or create some route properties.
		 * @param isNewRoute
		 */
		$scope.openEditRouteModal = function (isNewRoute) {
			routeDataBackup = angular.copy($scope.data.currentRouteData);
			if (isNewRoute) {
				$scope.newRouteMode = true;
				$scope.data.currentRouteData = {
					stop_points: []
				};
				$scope.data.currentRoute = undefined;
			} else {
				$scope.newRouteMode = false;
			}
			Utils.openModal($uibModal, "editRouteModal.html", $scope);
		};

		$scope.validateEditModal = form => {
			if (!$scope.newRouteMode) {
				//if not in newRouteMode, this is a route name modification => need to post route with new name
				$scope.postRoute(form);
			}
		};


		/**
		 * If currentRoute is provided, will update current route.
		 * Otherwise will create a route with provided informations.
		 */
		$scope.postRoute = form => {
			if (form.$valid) {
				$scope.data.editingRoute = true;
				// Si première création
				if ($scope.data.currentRoute === undefined) {
					$scope.data.formToConfirm = form;
					//No impact analysis because this is a new route : directly sent to postRoutConfirm
					$scope.postRouteConfirm();
					return;
				}

				$scope.data.formToConfirm = form;
				$scope.data.impactList = [];
				ExploitationService.analysePostRoute(
					$scope.data.currentRouteData,
					$scope.data.currentNetwork,
					$scope.data.currentLine,
					$scope.data.currentRoute)
					.then((response) => {
						const data = response.data;
						// Si aucun pb, on valide définitivement
						if (data.length === 0) {
							$scope.postRouteConfirm();
						} else if (data.length === 1) {
							// Vérification si modification va conduire à des problèmes
							$scope.data.impactList = data;
							impactInfoModal = Utils.openModal($uibModal, "changePublishedNameAllVJ.html", $scope);
						} else if (data.length > 1) {
							// Vérification si modification va conduire à des problèmes
							$scope.data.impactList = data;
							impactInfoModal = Utils.openModal($uibModal, "impactInfoModal.html", $scope);
						}

					}).catch(() => {
					$scope.data.editingRoute = false;
					toastr.error("Problème lors de l'analyse des impacts.", "Erreur");
				});
			} else {
				$scope.data.editingRoute = false;
				toastr.error("Merci de vérifier les informations saisies", "Sauvegarde impossible");
				$location.hash("routeForm");
				$anchorScroll();
			}
		};

		$scope.closeImpactInfoModal = () => {
			$scope.data.editingRoute = false;
			impactInfoModal.close();
		}

		/**
		 * If currentRoute is provided, will update current route.
		 * Otherwise will create a route with provided informations.
		 */
		$scope.postRouteConfirm = () => {
			let form = $scope.data.formToConfirm;
			if (form.$valid) {
				$scope.data.validatedOrClosedConfirmationEditingRoute = false;
				ExploitationService.addOrUpdateRoute(
					$scope.data.currentRouteData,
					$scope.data.currentNetwork,
					$scope.data.currentLine,
					$scope.data.currentRoute,
					$scope.data.changePublishedNameAllVJ).then((response) => {
						const newRouteData = response.data;
					$scope.data.routeDataChanged = false;
					//refetch routes
					toastr.success(`<a href="#/e-iti/courses/route/${newRouteData.id}">Cliquez ici pour ajouter ou modifier des courses pour cet itinéraire</a>`,
						$scope.data.currentRoute ? "Itinéraire modifié avec succès" : "Itinéraire créé avec succès",
						{
							allowHtml: true
						});
					// rechargement des itinéraires
					ExploitationService.getRoutes($scope.data.currentLine, false)
						.then((response) => {
							$scope.data.routes = response.data;
							$scope.data.editingRoute = false;
							$scope.data.validatedOrClosedConfirmationEditingRoute = true;
						})
					$scope.newRouteMode = false;
					$location.path("e-iti/itineraires/" + newRouteData.id);
					if (impactInfoModal !== undefined) {
						impactInfoModal.close();
					}
				}).catch(() => {
					$scope.data.validatedOrClosedConfirmationEditingRoute = true;
					$scope.data.editingRoute = false;
					toastr.error("Problème lors de la sauvegarde de l'itinéraire.", "Erreur");
					if (impactInfoModal !== undefined) {
						impactInfoModal.close();
					}
				});
			} else {
				$scope.data.editingRoute = false;
				toastr.error("Merci de vérifier les informations saisies", "Sauvegarde impossible");
				$location.hash("routeForm");
				$anchorScroll();
			}
		};

		/**
		 * Open route deletion modal confirmation.
		 */
		$scope.openDeleteRouteModal = function () {
			deleteRouteModal = Utils.openModal($uibModal, "deleteRouteModal.html", $scope);
		};

		/**
		 * Delete a route.
		 * On successful return,
		 * - re-fetch routes
		 * - close the modal,
		 */
		$scope.deleteRoute = function () {
			ExploitationService.deleteRoute($scope.data.currentRoute).then(() => {

				ExploitationService.getRoutes($scope.data.currentLine).then((response) => {
						$scope.data.routes = response.data;
						deleteRouteModal.close();
						toastr.success("Itinéraire supprimé avec succès", "");
						$scope.data.currentRoute = undefined;
						$scope.data.currentRouteData = undefined;
						$scope.data.currentRouteTrace = [];
					})
					.catch(() => {
						toastr.error("", "Problème lors de la suppression de l'itinéraire.");
					});

			}).catch(() => {
				toastr.error("", "Problème lors de la suppression de l'itinéraire.");
			});
		};


		/**
		 * Display a simple marker on the map.
		 * @param point
		 */
		$scope.showPointOnMap = function (point) {
			let leafletStopPointMarker = formatMarkerFromStopPoint(point, "purple");
			OkinaLeafletService.createMarkerWithName(point.id, leafletStopPointMarker);
		};

		/**
		 * Hide the 'imple marker layer' on the map.
		 */
		$scope.hidePointOnMap = function (stopPoint) {
			OkinaLeafletService.deleteMarkerWithName(stopPoint.id);
		};


		$scope.download = function (format) {
			ExploitationService.downloadMapMatching($routeParams.routeId, format)
				.then((response) => {
					const data = response.data;
					let blob;
					if (format === "GEOJSON") {
						blob = new Blob([JSON.stringify(data)], {type: "application/json"});
						window.saveAs(blob, "export_geojson_" + $routeParams.routeId + ".json");
					} else if (format === "GPX") {
						blob = new Blob([data], {type: "octet/stream"});
						window.saveAs(blob, "export_gpx_" + $routeParams.routeId + ".gpx");
					} else {
						blob = new Blob([data], {type: "octet/stream"});
						window.saveAs(blob, "export_kml_" + $routeParams.routeId + ".kml");
					}
					toastr.success("Exportation terminée", "");
				})
				.catch(() => {
					toastr.error("", "Problème lors de l'exportation des données.");
				});
		};

		/**
		 * @param sp stop-point
		 * @param boardingColorOption
		 * @returns {{lng: *, icon: {number: *, markerColor: *, prefix: null, icon: string, type: string}, id: *, message: string, lat: *}}
		 */
		function formatMarkerFromStopPoint(sp, boardingColorOption) {

			let color = boardingColorOption && typeof (boardingColorOption) === "string" ? boardingColorOption : "blue";
			if (sp.id === $scope.data.currentRouteData.arrivalStopPoint) {
				color = "red";
			} else if (sp.id === $scope.data.currentRouteData.departureStopPoint) {
				color = "green";
			}

			return formatMarkerFromStopPointShow(sp, color);
		}

		/**
		 * @param sp stop-point
		 * @param color
		 * @returns {{lng: *, icon: {number: *, markerColor: *, prefix: null, icon: string, type: string}, id: *, message: string, lat: *}}
		 */
		function formatMarkerFromStopPointShow(sp, color) {
			const index = sp.position + 1;
			let icon;
			if (color !== "orange") {
				icon = {
					type: "extraMarker",
					icon: "fa-number",
					number: index,
					prefix: "",
					markerColor: color
				}
			} else {
				icon = {
					type: "awesomeMarker",
					icon: "circle",
					prefix: "fa",
					markerColor: color
				}
			}
			return {
				lat: sp.latitude,
				lng: sp.longitude,
				id: sp.id,
				sa_id: sp.stop_area_id ? stop_area_id : null,
				icon: icon,
				message: ""
			};

		}

		/**
		 * Construit la popup de l'affichage des liaison d'un point d'arret.
		 * @param HTMLElements
		 * @returns {string}
		 */
		function popupHTMLTemplateForPoint(HTMLElements) {
			const popupHTML =
				"<div class='okina-leaflet-default-pop-up'>" +
				"<okina-popup-detail-stop-area callback='' stop-point='data.pointToDisplay'></okina-popup-detail-stop-area>" +
				HTMLElements +
				"</div>";
			return Utils.compileHtmlElement(popupHTML, $compile, $scope);
		}

		function popupHTMLTemplateForBoardingPoint(point) {
			const templateHTML = "<hr> <div class='text-center'>" +
				"<button class='btn btn-primary' ng-click='addRouteDataStopPointsById(" + point.id + ")'>Ajouter à l'itinéraire</button></div>" +
				"</div>";

			return popupHTMLTemplateForPoint(templateHTML);
		}

		function popupHTMLTemplateForPointOfItinerary(point) {
			const templateHTML = "<hr> <div class='text-center'>" +
				"<button  ng-if='isMarketing' class='btn btn-primary' ng-click='deletePointFromRouteWithId(" + point.id + ")'>Supprimer de l'itinéraire</button></div>" +
				"</div>";

			return popupHTMLTemplateForPoint(templateHTML);

		}

		/******************
		 * WATCHERS
		 ******************/

		/**
		 * Watch stop points collection. This collection is updated whenever a route is selected.
		 * When collection changes, compute data to be displayed onto the map by calling the #redrawMap function.
		 */
		$scope.$watchCollection("data.currentRouteData.stop_points", function (value, oldValue) {
			if (value !== oldValue) {
				if (value !== undefined && oldValue !== undefined && value != null) {
					$scope.data.currentRouteData.departureStopPoint = value[0].id;
					$scope.data.currentRouteData.arrivalStopPoint = value[value.length - 1].id;
					refreshDisplayedMarkers();
					$scope.data.routeDataChanged = oldRouteDifferentNewRoute(oldValue, value);
				}
			}
		});

		function oldRouteDifferentNewRoute(oldRoute, newRoute){
			for(let i = 0; i < oldRoute.length; i++){
				for(let y = 0; y < newRoute.length; y++){
					if(i === y && oldRoute[i].stop_point_id !== newRoute[y].stop_point_id){
						return true
					}
				}
			}
			return false;
		}

		// Si le boolean d'afifchage ou non des markers sur la carto change on rafraichi la carto
		$scope.toggleDisplayMarkerAvailableBoarding = () => {
			$scope.data.displayMarkerAvailableBoarding = !$scope.data.displayMarkerAvailableBoarding;

			refreshAvailableBoardingMarkersList($scope.data.currentMapAreaPoints);
		};

		/**
		 * Rafraichis l'ensemble des markers de la carto.
		 */
		function refreshDisplayedMarkers() {
			OkinaLeafletService.deleteAllMarkers();
			let currentPosition = 0;
			$scope.data.currentRouteData.stop_points.forEach(sp => {
				sp.position = currentPosition;
				currentPosition++;
				let leafletStopPointMarker = formatMarkerFromStopPoint(sp);
				OkinaLeafletService.createMarkerWithName(sp.id, leafletStopPointMarker);

				//Add popup event on each marker
				leafletStopPointMarker = OkinaLeafletService.getMarkerWithName(sp.id);
				leafletStopPointMarker.on('popupopen', (e) => {

					const clickedMarker = e.target;

					$scope.data.pointToDisplay = {
						id: clickedMarker.options.id
					};
					clickedMarker.setPopupContent(popupHTMLTemplateForPointOfItinerary($scope.data.pointToDisplay));
				});
			});

			if ($scope.data.currentMapAreaPoints) {
				refreshAvailableBoardingMarkersList($scope.data.currentMapAreaPoints);
			}

			adjustZIndex();
		}

		/**
		 * Rafraichis uniquement la liste des points disponibles (marker orange)
		 * @param currentMapAreaPoints
		 */
		function refreshAvailableBoardingMarkersList(currentMapAreaPoints) {
			// Clean des points d'arrêt boarding
			OkinaLeafletService.deleteMarkerWithNameStartingBy(MARKER_PREFIX);

			// Si on ne souhaite pas les afficher alors on sort de la méthode
			if (!$scope.data.displayMarkerAvailableBoarding) {
				return;
			}

			const zoomLevelToLoad = 11;
			OkinaLeafletService.getMap().then((map) => {
				const currentZoom = map.getZoom();
				// On n'affiche les PA seulement si on est a certain niveau de zoom
				if (currentZoom >= zoomLevelToLoad) {
					currentMapAreaPoints.forEach(sa => {
						sa.liaisons = null;
						let marker = formatMarkerFromStopPoint(sa, "orange");

						if (isMarkerCloseEnoughToItineraryToBeDisplayed(marker) && OkinaLeafletService.getMarkerWithName(sa.id) == null) {
							OkinaLeafletService.createMarkerWithName(MARKER_PREFIX + sa.id, marker);
							let markerLeaflet = OkinaLeafletService.getMarkerWithName(MARKER_PREFIX + sa.id);
							markerLeaflet.setZIndexOffset(100 - markerLeaflet.y);

							//Add popup event on each marker;
							markerLeaflet.on('popupopen', (e) => {
								const clickedMarker = e.target;
								const stopPoint = $scope.data.currentRouteData.stop_points.find(sp => sp.id === clickedMarker.options.id);
								$scope.data.pointToDisplay = stopPoint !== undefined ? stopPoint : clickedMarker.options;
								clickedMarker.setPopupContent(popupHTMLTemplateForBoardingPoint(sa));
							});
						}
					});

					adjustZIndex();
				}
			});
		}

		/******************
		 * UTILS
		 ******************/

		/**
		 * Détermine si le marker est a moins de 5km d'au moins un des points de l'itinéraire.
		 * @param marker
		 * @returns {boolean}
		 */
		function isMarkerCloseEnoughToItineraryToBeDisplayed(marker) {
			return $scope.data.currentRouteData != null
				&& $scope.data.currentRouteData.stop_points != null
				&& $scope.data.currentRouteData.stop_points
					.some(sp =>
						MapUtils.getDistanceFromLatLonInKm(marker.lat, marker.lng, sp.latitude, sp.longitude) <= 5 // Arbitrairement filtré sur 5km
					);
		}

		/**
		 * Réajuste le zIndex des points de l'itinéraire pour s'assurer qu'ils soient toujours affichés au dessus des autres markers
		 */
		function adjustZIndex() {
			OkinaLeafletService.getMap().then(() => {
				$scope.data.currentRouteData.stop_points
					.forEach(sp => {
						let marker = OkinaLeafletService.getMarkerWithName(sp.id);
						if (marker != null) {
							marker.setZIndexOffset(101 - marker.y);
						}
					});
			});
		}

		$scope.$on("$locationChangeStart", function( event ) {
			if($scope.data.routeDataChanged){
				routeDataChangedModal = Utils.openModal($uibModal, "routeDataChangedModal.html", $scope, "md");
				nextPath = $location.path();
				event.preventDefault();
			}
		});

		$scope.closeRouteDataChangedModal = (leaveWithoutSave) => {
			routeDataChangedModal.close();
			if(leaveWithoutSave){
				$scope.data.routeDataChanged = false;
				$location.path(nextPath);
			}
		}

		$scope.$watch("data.currentRoute", () => {
			if ($scope.data.currentRoute === undefined) {
				$scope.data.currentRouteData = undefined;
			}
		});
	}]);
